// ** Icons Import
import { User,  Edit, Edit3} from 'react-feather'

export default [
  {
    header: 'Primary - Secondary'
  },
  {
    id: 'nilai_&_capaian',
    title: 'Nilai & Capaian Ko..',
    icon: <Edit size={20} />,
    navLink: '/forms/nilai-capaian-kompetensi'
  },
  {
    id: 'profil_pancasila',
    title: 'Profil Pelajar Panca..',
    icon: <User size={20} />,
    navLink: '/forms/profil-pancasila'
  },
  {
    header: 'Special Need'
  },
  {
    id: 'sen_nilai_&_capaian',
    title: 'SEN Nilai & Capaian..',
    icon: <Edit3 size={20} />,
    navLink: '/forms/sen'
  }
  // {
  //   id: 'jasmani_dan_kesehatan',
  //   title: 'Jasmani & Kesehat..',
  //   icon: <Activity size={20} />,
  //   navLink: '/forms/form-repeater'
  // },
  // {
  //   id: 'kehadiran_dan_laporan',
  //   title: 'Kehadiran & Laporan',
  //   icon: <FileText size={20} />,
  //   navLink: '/forms/kehadiran-dan-laporan'
  // }
]
